const contact = {
    title: '聯繫我們',
    description: '加入我們的社區，在這裡你可以給我們提供產品建議，尋求幫助或和其他開發者交流心得',
    discord: {
        title: 'Discord 頻道',
        description: '加入我們的公共頻道，和其他開發者一起交流使用經驗',
        button: '立即加入',
    },
    github: {
        title: 'GitHub',
        description: '通過 GitHub 給我們提一個 issue',
        button: '前往頁面',
    },
    email: {
        title: '郵件聯繫',
        description: '通過郵件聯繫獲取信息或尋求幫助',
        button: '發送郵件',
    },
};
export default contact;
